import { ChevronDown } from 'lucide-react';
import type { MouseEvent } from 'react';
import { DetailBlockProps } from './types';

export default function DetailBlock({
  title,
  content,
  emptyText,
  isOpen,
  onToggle,
  onboardingKey,
}: DetailBlockProps) {
  // A lone dash is how a blank answer has sometimes come back.
  const text = content?.trim().replace(/^[-–—]$/, '');

  const handleSummaryClick = (e: MouseEvent<HTMLElement>) => {
    e.preventDefault();
    onToggle();
  };

  return (
    <details open={isOpen} className="group" data-onboarding={onboardingKey}>
      <summary
        onClick={handleSummaryClick}
        className="hover:text-prompt-safecomvulcan/80 flex cursor-pointer items-center gap-1 text-sm font-medium text-prompt-safecomvulcan"
      >
        <ChevronDown
          size={14}
          className="transition-transform duration-200 group-open:rotate-180"
        />
        {title}
      </summary>
      <div className="ml-5 mt-1 text-sm text-prompt-safecomabbey">
        {text || <span className="italic">{emptyText}</span>}
      </div>
    </details>
  );
}
